/** A section offered under another in the nav, which scrolls like any item. */
export type MarketingSubNavItem = {
  title: string;
  href: string;
  /**
   * The section whose nav item stays marked while the page scrolls here, for
   * one that has no item of its own. Its own anchor where this is not set.
   */
  pinId?: string;
};

export type MarketingNavItem = {
  title: string;
  href: string;
  /** Offered under this one, in a dropdown, where it has any */
  items?: MarketingSubNavItem[];
};

// The nav: seven items, each a section of the homepage, in the order the
// sections come down the page. News follows Team there, so it does here.
// Fund is reached two ways on purpose: an item of its own, for the reader
// who came to fund something, and one of the three audiences under Network,
// for the reader working through who the network is for. Both lead to the
// same section.
export const marketingNavigationItemsData: MarketingNavItem[] = [
  {
    title: "Network",
    href: "/#network",
    // The three audiences the network is argued to. Organizations and
    // Participants have no nav item of their own, so each keeps Network
    // marked while the page scrolls to it. Funders has Fund.
    items: [
      { title: "Organizations", href: "/#organizations", pinId: "network" },
      { title: "Participants", href: "/#participants", pinId: "network" },
      { title: "Funders", href: "/#fund" },
    ],
  },
  { title: "Fund", href: "/#fund" },
  { title: "Research", href: "/#research" },
  { title: "Team", href: "/#team" },
  { title: "News", href: "/#news" },
  { title: "Vision", href: "/#vision" },
  { title: "Donate", href: "/#donate" },
];
